webpackJsonp([226020273838829],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'svg',
	    { width: '14', height: '11', viewBox: '0 0 14 11' },
	    _react2.default.createElement(
	      'title',
	      null,
	      'switch-check'
	    ),
	    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
	  );
	};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(225);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _check = __webpack_require__(451);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _x = __webpack_require__(454);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _util = __webpack_require__(453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toggle = function (_PureComponent) {
	  _inherits(Toggle, _PureComponent);
	
	  function Toggle(props) {
	    _classCallCheck(this, Toggle);
	
	    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
	    _this.state = {
	      checked: !!(props.checked || props.defaultChecked),
	      hasFocus: false
	    };
	    return _this;
	  }
	
	  _createClass(Toggle, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('checked' in nextProps) {
	        this.setState({ checked: !!nextProps.checked });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var checkbox = this.input;
	      if (event.target !== checkbox && !this.moved) {
	        this.previouslyChecked = checkbox.checked;
	        event.preventDefault();
	        checkbox.focus();
	        checkbox.click();
	        return;
	      }
	
	      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;
	
	      this.setState({ checked: checked });
	    }
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      this.startX = (0, _util.pointerCoord)(event).x;
	      this.activated = true;
	    }
	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(event) {
	      if (!this.activated) return;
	      this.moved = true;
	
	      if (this.startX) {
	        var currentX = (0, _util.pointerCoord)(event).x;
	        if (this.state.checked && currentX + 15 < this.startX) {
	          this.setState({ checked: false });
	          this.startX = currentX;
	          this.activated = true;
	        } else if (currentX - 15 > this.startX) {
	          this.setState({ checked: true });
	          this.startX = currentX;
	          this.activated = currentX < this.startX + 5;
	        }
	      }
	    }
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd(event) {
	      if (!this.moved) return;
	      var checkbox = this.input;
	      event.preventDefault();
	
	      if (this.startX) {
	        var endX = (0, _util.pointerCoord)(event).x;
	        if (this.previouslyChecked === true && this.startX + 4 > endX) {
	          if (this.previouslyChecked !== this.state.checked) {
	            this.setState({ checked: false });
	            this.previouslyChecked = this.state.checked;
	            checkbox.click();
	          }
	        } else if (this.startX - 4 < endX) {
	          if (this.previouslyChecked !== this.state.checked) {
	            this.setState({ checked: true });
	            this.previouslyChecked = this.state.checked;
	            checkbox.click();
	          }
	        }
	
	        this.activated = false;
	        this.startX = null;
	        this.moved = false;
	      }
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(event) {
	      var onFocus = this.props.onFocus;
	
	
	      if (onFocus) {
	        onFocus(event);
	      }
	
	      this.setState({ hasFocus: true });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(event) {
	      var onBlur = this.props.onBlur;
	
	
	      if (onBlur) {
	        onBlur(event);
	      }
	
	      this.setState({ hasFocus: false });
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon(type) {
	      var icons = this.props.icons;
	
	      if (!icons) {
	        return null;
	      }
	      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          _icons = _props.icons,
	          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);
	
	      var classes = (0, _classnames2.default)('react-toggle', {
	        'react-toggle--checked': this.state.checked,
	        'react-toggle--focus': this.state.hasFocus,
	        'react-toggle--disabled': this.props.disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes,
	          onClick: this.handleClick,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd },
	        _react2.default.createElement(
	          'div',
	          { className: 'react-toggle-track' },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-toggle-track-check' },
	            this.getIcon('checked')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'react-toggle-track-x' },
	            this.getIcon('unchecked')
	          )
	        ),
	        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
	        _react2.default.createElement('input', _extends({}, inputProps, {
	          ref: function ref(_ref) {
	            _this2.input = _ref;
	          },
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          className: 'react-toggle-screenreader-only',
	          type: 'checkbox' }))
	      );
	    }
	  }]);
	
	  return Toggle;
	}(_react.PureComponent);
	
	exports.default = Toggle;
	
	
	Toggle.displayName = 'Toggle';
	
	Toggle.defaultProps = {
	  icons: {
	    checked: _react2.default.createElement(_check2.default, null),
	    unchecked: _react2.default.createElement(_x2.default, null)
	  }
	};
	
	Toggle.propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  defaultChecked: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  'aria-labelledby': _propTypes2.default.string,
	  'aria-label': _propTypes2.default.string,
	  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
	    checked: _propTypes2.default.node,
	    unchecked: _propTypes2.default.node
	  })])
	};

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pointerCoord = pointerCoord;
	// Copyright 2015-present Drifty Co.
	// http://drifty.com/
	// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts
	
	function pointerCoord(event) {
	  // get coordinates for either a mouse click
	  // or a touch depending on the given event
	  if (event) {
	    var changedTouches = event.changedTouches;
	    if (changedTouches && changedTouches.length > 0) {
	      var touch = changedTouches[0];
	      return { x: touch.clientX, y: touch.clientY };
	    }
	    var pageX = event.pageX;
	    if (pageX !== undefined) {
	      return { x: pageX, y: event.pageY };
	    }
	  }
	  return { x: 0, y: 0 };
	}

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'svg',
	    { width: '10', height: '10', viewBox: '0 0 10 10' },
	    _react2.default.createElement(
	      'title',
	      null,
	      'switch-x'
	    ),
	    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
	  );
	};

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Fast (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-150.000000, -1055.000000)"},React.createElement("g",{"id":"Group-8","transform":"translate(207.000000, 1106.000000)","fillRule":"nonzero"},[React.createElement("path",{"d":"M107.478963,12.3167155 L117.600921,-5.32907052e-15 L236,0 L236,36.9501466 L87.2350493,36.9501466 L97.3570064,24.6334311 L174.530482,24.6334311 L174.530482,12.3167155 L107.478963,12.3167155 Z M107.683483,61.5835777 L124.527735,49.2668622 L236,49.2668622 L236,86.2170088 L73.9949789,86.2170088 L90.8392309,73.9002933 L174.530482,73.9002933 L174.530482,61.5835777 L107.683483,61.5835777 Z M236,98.5337243 L236,135.483871 L63.8853503,135.483871 L63.8853503,98.5337243 L236,98.5337243 Z M76.1792539,123.167155 L174.530482,123.167155 L174.530482,110.85044 L76.1792539,110.85044 L76.1792539,123.167155 Z M226.779572,117.008798 C226.779572,114.442815 225.883142,112.26173 224.090281,110.465543 C222.29742,108.669355 220.120375,107.771261 217.559145,107.771261 C214.997915,107.771261 212.820869,108.669355 211.028008,110.465543 C209.235147,112.26173 208.338717,114.442815 208.338717,117.008798 C208.338717,119.57478 209.235147,121.755865 211.028008,123.552053 C212.820869,125.34824 214.997915,126.246334 217.559145,126.246334 C220.120375,126.246334 222.29742,125.34824 224.090281,123.552053 C225.883142,121.755865 226.779572,119.57478 226.779572,117.008798 Z M226.779572,67.7419355 C226.779572,65.1759531 225.883142,62.994868 224.090281,61.1986804 C222.29742,59.4024927 220.120375,58.5043988 217.559145,58.5043988 C214.997915,58.5043988 212.820869,59.4024927 211.028008,61.1986804 C209.235147,62.994868 208.338717,65.1759531 208.338717,67.7419355 C208.338717,70.3079179 209.235147,72.4890029 211.028008,74.2851906 C212.820869,76.0813783 214.997915,76.9794721 217.559145,76.9794721 C220.120375,76.9794721 222.29742,76.0813783 224.090281,74.2851906 C225.883142,72.4890029 226.779572,70.3079179 226.779572,67.7419355 Z M226.779572,18.4750733 C226.779572,15.9090909 225.883142,13.7280059 224.090281,11.9318182 C222.29742,10.1356305 220.120375,9.23753666 217.559145,9.23753666 C214.997915,9.23753666 212.820869,10.1356305 211.028008,11.9318182 C209.235147,13.7280059 208.338717,15.9090909 208.338717,18.4750733 C208.338717,21.0410557 209.235147,23.2221408 211.028008,25.0183284 C212.820869,26.8145161 214.997915,27.71261 217.559145,27.71261 C220.120375,27.71261 222.29742,26.8145161 224.090281,25.0183284 C225.883142,23.2221408 226.779572,21.0410557 226.779572,18.4750733 Z","id":"Combined-Shape","fill":"#FFFFFF","key":0}),React.createElement("polygon",{"id":"Shape","fill":"#B1DDDF","points":"71.3994359 0 21.6092461 60.5913978 67.6543508 60.5913978 26.9612498 109.424972 110.189171 48.5677355 66.0068084 48.5677355 105.92009 4.01112835e-15","key":1})])))]);
	}
	
	Fast.displayName = "Fast";
	
	Fast.defaultProps = {"width":"428px","height":"243px","viewBox":"0 0 428 243","version":"1.1"};
	
	module.exports = Fast;
	
	Fast.default = Fast;


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Languages (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-943.000000, -1282.000000)"},[React.createElement("g",{"id":"Group-6","transform":"translate(972.000000, 1352.000000)","fillRule":"nonzero","fill":"#FFFFFF","key":0},[React.createElement("path",{"d":"M48.5231419,0.000850719456 C44.4734145,0.0198381827 40.605825,0.361031273 37.2025891,0.95700512 C27.177761,2.70927673 25.3577534,6.37618213 25.3577534,13.1394003 L25.3577534,22.0718393 L49.0480123,22.0718393 L49.0480123,25.048996 L25.3575576,25.048996 L16.4668804,25.048996 C9.58187379,25.048996 3.55330681,29.1429256 1.66808215,36.9306918 C-0.507192152,45.8577057 -0.604332338,51.4289762 1.66808215,60.7500769 C3.35217179,67.6878635 7.37310963,72.6315789 14.258312,72.6315789 L22.4033992,72.6315789 L22.4033992,61.9232309 C22.4033992,54.1885521 29.1687431,47.3643028 37.2023932,47.3643028 L60.8650376,47.3643028 C67.451769,47.3643028 72.7096774,41.9995695 72.7096774,35.4552884 L72.7096774,13.1392066 C72.7096774,6.78886884 67.2939162,2.01681557 60.8650376,0.95681137 C56.7955297,0.286437667 52.5726734,-0.0183304934 48.5231419,0.000850719456 Z M35.7118006,7.18450557 C38.1587149,7.18450557 40.157335,9.19368918 40.157335,11.6639969 C40.157335,14.1255859 38.1587149,16.1167508 35.7118006,16.1167508 C33.2554856,16.1167508 31.2662661,14.1255859 31.2662661,11.6639969 C31.2662661,9.19368918 33.2554856,7.18450557 35.7118006,7.18450557 Z","id":"path1948_1_","fillOpacity":"0.659731658","key":0}),React.createElement("path",{"d":"M75.4944266,25.2631579 L75.4944266,35.8900067 C75.4944266,44.1300089 68.5944773,51.0634183 60.7258809,51.0634183 L37.1111009,51.0634183 C30.6428992,51.0634183 25.2903226,56.6678781 25.2903226,63.2249794 L25.2903226,86.0143784 C25.2903226,92.4992649 30.8612162,96.3149747 37.1111009,98.1747524 C44.5950529,100.402331 51.7705859,100.80614 60.7256854,98.1747524 C66.6773144,96.4313098 72.5462682,92.9196934 72.5462682,86.0143784 L72.5462682,76.8925646 L48.9324655,76.8925646 L48.9324655,73.8528174 L72.5460728,73.8528174 L84.3666556,73.8528174 C91.2380694,73.8528174 93.7990425,69.0017654 96.1878248,61.7199444 C98.656155,54.2224683 98.5513941,47.0128621 96.1878248,37.3966244 C94.4899561,30.4733053 91.2466691,25.2635536 84.3666556,25.2635536 L75.4944266,25.2635536 L75.4944266,25.2631579 Z M62.213837,82.9732462 C64.6645767,82.9732462 66.6501469,85.0049544 66.6501469,87.5188199 C66.6501469,90.0411928 64.6645767,92.0938729 62.213837,92.0938729 C59.7720879,92.0938729 57.7779179,90.0411928 57.7779179,87.5188199 C57.7777225,85.0049544 59.7718925,82.9732462 62.213837,82.9732462 Z","id":"path1950_1_","key":1})]),React.createElement("g",{"id":"Group-7","transform":"translate(1243.000000, 1366.000000)","fillRule":"nonzero","fill":"#FFFFFF","key":1},[React.createElement("path",{"d":"M20.6675867,1.10204082 L36.4534884,1.10204082 L36.4534884,45.1931079 C36.4534884,65.0651829 26.89913,72 11.6319144,72 C7.89332577,72 3.11605287,71.3790385 0,70.3441027 L1.76563207,57.6136452 C3.94666288,58.3381002 6.75079179,58.8555681 9.8662823,58.8555681 C16.513037,58.8555681 20.6675867,55.8538807 20.6675867,45.089988 L20.6675867,1.10204082 Z","id":"Shape","key":0}),React.createElement("path",{"d":"M50.3435314,54.7236671 C54.4879099,56.8961155 61.1191773,59.0685639 67.8538625,59.0685639 C75.1067587,59.0685639 78.9403229,56.068774 78.9403229,51.4135541 C78.9403229,47.172285 75.6247826,44.5862592 67.2322338,41.6895369 C55.6275625,37.5515221 47.9606212,31.1378047 47.9606212,20.896769 C47.9606212,9.0001167 58.0108467,0 74.3813382,0 C82.3596549,0 88.0579182,1.55217564 92.2026707,3.51736854 L88.6795469,16.1379214 C85.9858224,14.7933747 80.9086268,12.8276216 74.1745026,12.8276216 C67.3360256,12.8276216 64.0202984,16.0344803 64.0202984,19.5518489 C64.0202984,24.0001867 67.8538625,25.9653796 76.9720189,29.4829349 C89.3013627,34.0347137 95,40.4484312 95,50.3793305 C95,62.068914 86.0894272,72 66.9214195,72 C58.9431028,72 51.0683908,69.8273649 47.1317829,67.6551032 L50.3435314,54.7236671 Z","id":"Shape","key":1})]),React.createElement("g",{"id":"Ruby-Programming-Language-595b40b85ba036ed117da9b2","transform":"translate(1102.000000, 1347.000000)","fillRule":"nonzero","key":2},[React.createElement("polygon",{"id":"Shape","fill":"#FFFFFF","points":"95.32 32.6 90.84 90.84 32.6 95.32","key":0}),React.createElement("polygon",{"id":"Shape","fillOpacity":"0.192425272","fill":"#B8E8DF","points":"63.96 63.96 90.84 90.84 95.32 32.6","key":1}),React.createElement("ellipse",{"id":"Oval","fill":"#E3F6F3","transform":"translate(54.999328, 55.000000) rotate(-45.000000) translate(-54.999328, -55.000000) ","cx":"54.999328","cy":"55","rx":"50.6705541","ry":"26.1271094","key":2}),React.createElement("polygon",{"id":"Shape","fill":"#F9FDFC","points":"23.64 39.32 39.32 23.64 57.24 14.68 70.68 23.64 63.96 43.8 43.8 61.72 23.64 68.44 14.68 55","key":3}),React.createElement("path",{"d":"M70.68,23.64 L57.24,14.68 L81.88,14.68 L70.68,23.64 Z M95.32,34.84 L70.68,23.64 L63.96,43.8 L95.32,34.84 Z M43.8,61.72 L73.4464,73.4464 L63.96,43.8 L43.8,61.72 Z M23.64,68.44 L32.6,95.32 L43.8,61.72 L23.64,68.44 Z M14.68,55 L14.68,79.64 L23.64,68.44 L14.68,55 Z","id":"Shape","fill":"#B8E8DF","key":4})])]))]);
	}
	
	Languages.displayName = "Languages";
	
	Languages.defaultProps = {"width":"428px","height":"243px","viewBox":"0 0 428 243","version":"1.1"};
	
	module.exports = Languages;
	
	Languages.default = Languages;


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(43);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fullLogoOnWhite = __webpack_require__(55);
	
	var _fullLogoOnWhite2 = _interopRequireDefault(_fullLogoOnWhite);
	
	var _fast = __webpack_require__(123);
	
	var _fast2 = _interopRequireDefault(_fast);
	
	var _languages = __webpack_require__(124);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _reactStripeCheckout = __webpack_require__(78);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	var _reactToggle = __webpack_require__(452);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	__webpack_require__(315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STRIPE_PUBLIC_KEY = "pk_test_f1VXBMrmaKoYGGYAtqCHPuga";
	
	var onSelectorChange = function onSelectorChange() {
	  document.location = "http://graphene-python.org/";
	};
	
	var SubscribePage = function (_React$Component) {
	  _inherits(SubscribePage, _React$Component);
	
	  function SubscribePage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubscribePage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      annual: false,
	      subscribedTo: null
	    }, _this.onToken = function (plan) {
	      _this.setState({ subscribedTo: plan });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SubscribePage.prototype.handleTermChange = function handleTermChange() {
	    this.setState({ annual: !this.state.annual });
	  };
	
	  SubscribePage.prototype.renderSubscribe = function renderSubscribe(plan) {
	    return _react2.default.createElement(
	      _reactStripeCheckout2.default,
	      {
	        ComponentClass: "div",
	        token: this.onToken.bind(null, plan),
	        name: "Quiver Subscription",
	        description: "Setup the payment details",
	        image: (0, _gatsbyLink.withPrefix)("/static/logo.png"),
	        stripeKey: STRIPE_PUBLIC_KEY,
	        allowRememberMe: false,
	        panelLabel: "Save subscription details",
	        billingAddress: true
	      },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "button primary subscribe",
	          href: "/signup?trial&plan=" + plan + "&period=" + (this.state.annual ? "annual" : "monthly")
	        },
	        "Start trial"
	      )
	    );
	  };
	
	  SubscribePage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "container", "data-jsx": 1816252121
	      },
	      _react2.default.createElement(
	        "header",
	        {
	          "data-jsx": 1816252121
	        },
	        _react2.default.createElement(
	          "h1",
	          {
	            "data-jsx": 1816252121
	          },
	          "Quiver Packages"
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: (0, _gatsbyLink.withPrefix)("/static/quiver-flyer.pdf"), "data-jsx": 1816252121
	          },
	          "See PDF Flyer"
	        )
	      ),
	      _react2.default.createElement(
	        "label",
	        { className: "toggle", "data-jsx": 1816252121
	        },
	        _react2.default.createElement(_reactToggle2.default, {
	          defaultChecked: this.state.annual,
	          icons: false,
	          disabled: !!this.state.subscribedTo,
	          onChange: this.handleTermChange.bind(this)
	        }),
	        " ",
	        _react2.default.createElement(
	          "span",
	          {
	            "data-jsx": 1816252121
	          },
	          "Show annual pricing"
	        )
	      ),
	      this.state.subscribedTo ? _react2.default.createElement(
	        "p",
	        {
	          "data-jsx": 1816252121
	        },
	        "Payment details for the ",
	        this.state.subscribedTo,
	        " subscription plan saved correctly. We will send you an email with the integration instructions soon."
	      ) : _react2.default.createElement(
	        "ol",
	        { className: "packages", "data-jsx": 1816252121
	        },
	        _react2.default.createElement(
	          "li",
	          {
	            "data-jsx": 1816252121
	          },
	          _react2.default.createElement(
	            "h2",
	            {
	              "data-jsx": 1816252121
	            },
	            "Cloud"
	          ),
	          _react2.default.createElement(
	            "h4",
	            { className: "plan-price", "data-jsx": 1816252121
	            },
	            this.state.annual ? "$2,000/year" : "$200/month"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              "data-jsx": 1816252121
	            },
	            "The Cloud package is the right fit for small or growing companies who are just getting started with GraphQL. It is focused primarily on improving the speed of your GraphQL queries. The Cloud package includes all of the foundational tools you\u2019ll need: quiver package, server plugins, plus world- class support to help you make the most of it."
	          ),
	          this.renderSubscribe("basic")
	        ),
	        _react2.default.createElement(
	          "li",
	          {
	            "data-jsx": 1816252121
	          },
	          _react2.default.createElement(
	            "h2",
	            {
	              "data-jsx": 1816252121
	            },
	            "Enterprise"
	          ),
	          _react2.default.createElement(
	            "h4",
	            { className: "plan-price", "data-jsx": 1816252121
	            },
	            "*",
	            _react2.default.createElement(
	              "a",
	              { href: "mailto:contact@graphql-quiver.com", "data-jsx": 1816252121
	              },
	              "contact us"
	            ),
	            " for",
	            " ",
	            this.state.annual ? "annual" : "monthly",
	            " pricing"
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              "data-jsx": 1816252121
	            },
	            "Quiver Enterprise is a step up in functionality from the Cloud package. It supports more customized integration and is ideal for companies that need to personalize the way the engine works to maximize performance on their environment."
	          ),
	          this.renderSubscribe("professional")
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: 1816252121,
	        css: "h1[data-jsx=\"1816252121\"]{text-align:center}.subscribe[data-jsx=\"1816252121\"]{width:100%;text-align:center}.toggle[data-jsx=\"1816252121\"]{display:block;width:100%;text-align:center}.button[data-jsx=\"1816252121\"]{cursor:pointer}.plan-price[data-jsx=\"1816252121\"]{color:#666}.packages[data-jsx=\"1816252121\"]{text-align:center}.packages[data-jsx=\"1816252121\"] li[data-jsx=\"1816252121\"]{width:300px;vertical-align:top;display:inline-block;text-align:center;padding:20px;margin:20px;background:#fafafa;box-shadow:0 2px 4px 0 rgba(0,0,0,0.1)}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/pages/pricing.js */"
	      })
	    );
	  };
	
	  return SubscribePage;
	}(_react2.default.Component);
	
	exports.default = SubscribePage;
	module.exports = exports["default"];

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-7869b16e29f10150f12d.js